var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routes-check",staticStyle:{"width":"100%","height":"100%"}},[_c('google-map',{attrs:{"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }